// removed by extract-text-webpack-plugin
module.exports = {"leftpicturebackground":"src-components-Section----LeftPictureBackgroundLarge-module---leftpicturebackground---2Ynea","fh5colabel":"src-components-Section----LeftPictureBackgroundLarge-module---fh5colabel---3jTMg","fh5colead":"src-components-Section----LeftPictureBackgroundLarge-module---fh5colead---3ikSl","row-bottom-padded-lg":"src-components-Section----LeftPictureBackgroundLarge-module---row-bottom-padded-lg---27h8x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/LeftPictureBackgroundLarge.module.scss
// module id = 431
// module chunks = 110243015079028